import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Typography, Input, Button, Space } from 'antd';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import {
  apiCreateCustomer,
  apiGetCustomerById,
  apiUpdateCustomer
} from '@services/ManageCustomers/CustomerServices';
import { showSuccess } from '@components/notification';
import moment from 'moment';

const { Title } = Typography;

const validationSchema = Yup.object({
  branch: Yup.string().required('Trường này là bắt buộc'),
  manage_group: Yup.string().required('Trường này là bắt buộc'),
  parent_device: Yup.string().required('Trường này là bắt buộc'),
  route: Yup.string().required('Trường này là bắt buộc'),
  code: Yup.string().required('Trường này là bắt buộc'),
  name: Yup.string().required('Trường này là bắt buộc'),
  address: Yup.string().required('Trường này là bắt buộc'),
  serial_number: Yup.string().required('Trường này là bắt buộc'),
  phone: Yup.string().required('Trường này là bắt buộc'),
  device_name: Yup.string().required('Trường này là bắt buộc'),
  install_time: Yup.string().required('Trường này là bắt buộc'),
  size: Yup.string().required('Trường này là bắt buộc'),
  type: Yup.string().required('Trường này là bắt buộc'),
  style: Yup.string().required('Trường này là bắt buộc'),
  inspection_date: Yup.string().required('Trường này là bắt buộc'),
  year_valid: Yup.string().required('Trường này là bắt buộc')
});

export const Detail = ({ disabled }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [customer, setCustomer] = useState({});
  const [loadingFetch, setLoadingFetch] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      id ? await apiUpdateCustomer(values, id) : await apiCreateCustomer(values);
      showSuccess({ message: 'Thành công!' });
      navigate('/customers');
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const fetch = async () => {
    try {
      setLoadingFetch(true);
      const res = await apiGetCustomerById(id);
      if (res) {
        setCustomer(res?.data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingFetch(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetch();
    }
  }, [id]);

  return (
    <>
      <Card
        title={id ? 'Thông tin khách hàng' : 'Thêm mới khách hàng'}
        loading={loadingFetch}
        bodyStyle={{ padding: '24px', paddingTop: '0px' }}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Formik
              enableReinitialize
              initialValues={{
                branch: customer?.branch ?? '',
                manage_group: customer?.manage_group ?? '',
                parent_device: customer?.parent_device ?? '',
                route: customer?.route ?? '',
                code: customer?.code ?? '',
                name: customer?.name ?? '',
                address: customer?.address ?? '',
                serial_number: customer?.serial_number ?? '',
                phone: customer?.phone ?? '',
                device_name: customer?.device_name ?? '',
                install_time: customer?.install_time
                  ? moment(customer?.install_time).format('DD/MM/YYYY')
                  : '',
                size: customer?.size ?? '',
                type: customer?.type ?? '',
                style: customer?.style ?? '',
                inspection_date: customer?.inspection_date
                  ? moment(customer?.inspection_date).format('DD/MM/YYYY')
                  : '',
                year_valid: customer?.year_valid ?? '',
                longitude: customer?.longitude ?? '',
                latitude: customer?.latitude ?? '',
                note: customer?.note ?? ''
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}>
              {({ setFieldValue, errors }) => (
                <Form>
                  <Row gutter={[16, 16]}>
                    <Col md={8} xs={24}>
                      <Title level={5}>Chi nhánh (*)</Title>
                      <Field name="branch">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập chi nhánh" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="branch" component="div" style={{ color: '#e11d48' }} />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Tổ quản lý (*)</Title>
                      <Field name="manage_group">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập tổ quản lý" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="manage_group" component="div" style={{ color: 'red' }} />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Đồng hồ khối (*)</Title>
                      <Field name="parent_device">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập mã đồng hồ khối"
                            disabled={disabled}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="parent_device" component="div" style={{ color: 'red' }} />
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col md={24} xs={24}>
                      <Title level={5}>Tên KH(*)</Title>
                      <Field name="name">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập tên" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="name" component="div" style={{ color: '#e11d48' }} />
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col md={8} xs={24}>
                      <Title level={5}>Tuyến (*)</Title>
                      <Field name="route">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập tuyến" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="route" component="div" style={{ color: '#e11d48' }} />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Danh bạ điểm dùng(*)</Title>
                      <Field name="code">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập danh bạ điểm dùng"
                            disabled={disabled}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="code" component="div" style={{ color: '#e11d48' }} />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Số serial (*)</Title>
                      <Field name="serial_number">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập số serial" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="serial_number" component="div" style={{ color: 'red' }} />
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col md={24} xs={24}>
                      <Title level={5}>Địa chỉ (*)</Title>
                      <Field name="address">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập địa chỉ" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="address" component="div" style={{ color: '#e11d48' }} />
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col md={8} xs={24}>
                      <Title level={5}>Số ĐT (*)</Title>
                      <Field name="phone">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập số điện thoại" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="phone" component="div" style={{ color: '#e11d48' }} />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Tên ĐH (*)</Title>
                      <Field name="device_name">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập tên đồng hồ" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="device_name" component="div" style={{ color: 'red' }} />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Ngày lắp (*)</Title>
                      <Field name="install_time">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập ngày lắp" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="install_time" component="div" style={{ color: 'red' }} />
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col md={8} xs={24}>
                      <Title level={5}>Cỡ (*)</Title>
                      <Field name="size">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập cỡ" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="size" component="div" style={{ color: '#e11d48' }} />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Loại ĐH (*)</Title>
                      <Field name="type">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập loại ĐH" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="type" component="div" style={{ color: '#e11d48' }} />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Kiểu ĐH (*)</Title>
                      <Field name="style">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập kiểu ĐH" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="style" component="div" style={{ color: '#e11d48' }} />
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col md={8} xs={24}>
                      <Title level={5}>Ngày kiểm định (*)</Title>
                      <Field name="inspection_date">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập ngày kiểm định" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage
                        name="inspection_date"
                        component="div"
                        style={{ color: '#e11d48' }}
                      />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Số năm hiệu lực (*)</Title>
                      <Field name="year_valid">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập năm hiệu lực" disabled={disabled} />
                        )}
                      </Field>
                      <ErrorMessage name="year_valid" component="div" style={{ color: 'red' }} />
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Vĩ độ (Latitude)</Title>
                      <Field name="latitude">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập vĩ độ" disabled={disabled} />
                        )}
                      </Field>
                    </Col>
                    <Col md={8} xs={24}>
                      <Title level={5}>Kinh độ (Longitude)</Title>
                      <Field name="longitude">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập kinh độ" disabled={disabled} />
                        )}
                      </Field>
                    </Col>
                    <Col md={16} xs={24}>
                      <Title level={5}>Ghi chú</Title>
                      <Field name="note">
                        {({ field }) => (
                          <Input {...field} placeholder="Nhập ghi chú" disabled={disabled} />
                        )}
                      </Field>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} style={{ marginTop: '32px' }}>
                    <Col>
                      <Space>
                        <Button
                          type="primary"
                          onClick={() => navigate(-1)}
                          icon={<ArrowLeftOutlined />}
                          style={{
                            color: 'var(--text)',
                            height: '36px',
                            backgroundColor: 'var(--surface)',
                            borderColor: '#ffff',
                            fontSize: '18px'
                          }}>
                          Quay lại
                        </Button>
                      </Space>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </Card>
    </>
  );
};
